 
import * as yup from 'yup'
export const PersonlSchema = yup.object().shape({
    firstname: yup.string().max(15).required('first name is a required field'),
    lastname: yup.string().max(15).required('last name is a required field'),
    email: yup.string().email().required('email is a required field'),
    
    
})